require('ubook/desktop/main/index.js');
